import { useCallback } from "react";
import { useStore } from "react-redux";
import { getLocalUser } from "../../../components/functions/utilities";
import { useAppDispatch } from "../../../redux/reduxHooks";
import type { RootState } from "../../../redux/store";
import type { ConnectionSocketPayload } from "../api/connectionHub.types";
import { applyConnectionSocketUpdate } from "../state/connectionHubSlice";
import { fetchConnectionAccounts } from "../state/connectionHub.thunks";

const touchedIpIds = (payload: ConnectionSocketPayload): Set<string> =>
  new Set([
    ...payload.channelBadges.map((badge) => badge.ipId),
    ...(payload.inboxGroups ?? []).flatMap((group) => group.covers.map((cover) => cover.ipId)),
    ...(payload.standalone ?? []).map((card) => card.connection.ipId),
  ]);

export const useConnectionSocket = () => {
  const dispatch = useAppDispatch();
  const store = useStore<RootState>();

  return useCallback((payload: ConnectionSocketPayload): void => {
    if (!payload) return;
    const { session, accountsByIpId } = store.getState().connectionHub;
    const localCompanyId = Number(getLocalUser()?.companyId);
    const effectiveCompanyId = session.agencyClientId ?? (Number.isFinite(localCompanyId) ? localCompanyId : null);
    if (payload.companyId !== effectiveCompanyId) return;
    dispatch(applyConnectionSocketUpdate(payload));
    touchedIpIds(payload).forEach((ipId) => {
      if (accountsByIpId[ipId]) {
        void dispatch(fetchConnectionAccounts({ ipId, agencyClientId: session.agencyClientId, silent: true }));
      }
    });
  }, [dispatch, store]);
};
